import {enumType} from 'common/enumType';

export const JobStatus = enumType({
   Aborting: 'Aborting',
   Cancelling: 'Cancelling',
   Complete: 'Complete',
   Delayed: 'Delayed',
   Queued: 'Queued',
   Running: 'Running',
   Terminating: 'Terminating',
});
export type IJobStatus = keyof typeof JobStatus.origin;

export const JobSubStatus = enumType({
   BUILDING_FILE_LIST: 'Building File List',
   PROCESSING_FILES: 'Processing Files',
   SENDING_EMAILS: 'Sending Emails',
   SENDING_PAGES: 'Sending Pages',
   VERIFYING_FILE_LIST: 'Verifying File List',
   WAITING_FOR_RETRY: 'Waiting for Retry',
   WRITING_AUDIT_TRAIL: 'Writing Audit Trail',
});
